import { Button } from "@/components/ui/button";
import { useState } from "react";
import { ChevronDown, ChevronUp, Link as LinkIcon } from "lucide-react";

interface CollapsibleSectionProps {
  title: string;
  children: React.ReactNode;
  highlightColor?: string;
  id?: string;
}

export const CollapsibleSection = ({
  title,
  children,
  highlightColor = "bg-white",
  id,
}: CollapsibleSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [isLinkCopied, setIsLinkCopied] = useState(false);

  const copyLink = () => {
    if (!id) return;
    const url = `${window.location.href.split('#')[0]}#${id}`;
    navigator.clipboard.writeText(url);
    setIsLinkCopied(true);
    setTimeout(() => setIsLinkCopied(false), 2000);
  };

  return (
    <div id={id} className="space-y-4 scroll-mt-24">
      <div className="flex items-center space-x-2">
        <Button
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex-1 bg-primary hover:bg-primary/90 text-primary-foreground shadow-sm transition-all duration-200"
        >
          <div className="flex justify-between items-center w-full px-4 py-2">
            <h2 className="font-serif text-xl font-semibold">{title}</h2>
            {isExpanded ? <ChevronUp className="ml-2" /> : <ChevronDown className="ml-2" />}
          </div>
        </Button>
        {id && (
          <Button
            variant="ghost"
            size="icon"
            className="hover:bg-sage-100"
            onClick={copyLink}
            title="Copy link to section"
          >
            <LinkIcon className="h-4 w-4" />
          </Button>
        )}
      </div>
      
      {isExpanded && (
        <div className={`animate-fade-in px-6 py-4 rounded-lg shadow-sm ${highlightColor}`}>
          {children}
        </div>
      )}
      
      {isLinkCopied && (
        <div className="absolute right-0 mt-2 bg-sage-800 text-white px-3 py-1 rounded text-sm">
          Link copied!
        </div>
      )}
    </div>
  );
};